import React, { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import SendDocumentTemplate from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SendDocument/FillInformation/Form/SendDocumentTemplate'
import SignDocuments from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SignDocuments/FillInformation/SignDocuments'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

type TaskTypeSetting = {
  value: TaskConfigurationTypes
  label: string
  component: () => JSX.Element
}

const UploadSelector = () => {
  const { associatedTaskItem: item, form } = useFormProvider()
  const formType = form?.values?.task_type

  const itemTaskType = formType || item?.taskType
  const isSimpleSignature = itemTaskType === TaskConfigurationTypes.SignDocuments

  const isItemTaskTypeForSignDocument = (type: TaskConfigurationTypes) =>
    [TaskConfigurationTypes.SignDocuments, TaskConfigurationTypes.SendDocumentTemplate].includes(
      type
    )
  const [taskType, setTaskType] = React.useState<TaskConfigurationTypes>(
    isSimpleSignature || !isItemTaskTypeForSignDocument(itemTaskType as TaskConfigurationTypes)
      ? TaskConfigurationTypes.SignDocuments
      : TaskConfigurationTypes.SendDocumentTemplate
  )

  useEffect(() => {
    form.setValues({
      task_type: taskType,
      document_completion_type: taskType,
    })

    if (taskType === TaskConfigurationTypes.SignDocuments) {
      const copy = form.get('task_type_configuration')?.value

      delete copy?.document_template_id

      form.setValues({
        task_type_configuration: copy,
      })
    }
  }, [taskType])

  const taskTypeSettings: TaskTypeSetting[] = [
    {
      value: TaskConfigurationTypes.SignDocuments,
      label: i18n.t(
        'processes.process_settings.tasks.form.super_tasks_module.send_document.type_selector.values.sign_documents'
      ),
      component: SignDocuments,
    },
    {
      value: TaskConfigurationTypes.SendDocumentTemplate,
      label: i18n.t(
        'processes.process_settings.tasks.form.super_tasks_module.send_document.type_selector.values.send_document_template'
      ),
      component: SendDocumentTemplate,
    },
  ]

  const taskTypeSetting = taskTypeSettings.find(
    (taskTypeSetting) => taskTypeSetting.value === taskType
  )

  const TaskTypeComponent = taskTypeSetting?.component

  return (
    <>
      <SelectField
        label={i18n.t(
          'processes.process_settings.tasks.form.super_tasks_module.send_document.type_selector.label'
        )}
        mandatory
        attachmentPosition="middle right"
        value={taskType}
        onChange={(value) => {
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          const newTaskType = value as TaskConfigurationTypes
          setTaskType(newTaskType)
        }}
        options={taskTypeSettings}
      />

      <Box paddingTop="s24">{TaskTypeComponent && <TaskTypeComponent />}</Box>
    </>
  )
}

export default UploadSelector
